import { render, staticRenderFns } from "./ContainerBox.vue?vue&type=template&id=e9a8113a&scoped=true&lang=html&"
import script from "./ContainerBox.vue?vue&type=script&lang=js&"
export * from "./ContainerBox.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBox.vue?vue&type=style&index=0&id=e9a8113a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a8113a",
  null
  
)

export default component.exports